import { render, staticRenderFns } from "./layerBox.vue?vue&type=template&id=981d9b5a&scoped=true"
import script from "./layerBox.vue?vue&type=script&lang=js"
export * from "./layerBox.vue?vue&type=script&lang=js"
import style0 from "./layerBox.vue?vue&type=style&index=0&id=981d9b5a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "981d9b5a",
  null
  
)

export default component.exports